import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Drawer } from "@mui/material";
import { DRAWER_WIDTH } from "../../../constants/customDashboard/style";
import { EditDashboardDisplay } from "./editDashboard";
import { AddItemsBase } from "./addItems/addItemsBase";
import { postDashboard } from "../../../api/dashboard";
import { EditLiveTrendGraph } from "./editLiveTrendGaph";
import { Confirm } from "../../trendPage/customGraph/modal/confirm";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  isOpenLiveTrendEditPage,
  setIsOpenLiveTrendEditPage,
} from "../../../model/slice/customDashboardSlice";

export const DashboardEditPage = React.memo((props) => {
  const {
    currentVessel,
    isDrawerOpen,
    setIsDrawerOpen,
    selectedDashboard,
    setSelectedDashboard,
    setDashboards,
    isLiveTrendAddonEnabled,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [drawerContent, setDrawerContent] = useState(); //channels, trends, liveTrends
  const [editingLiveTrendChart, setEditingLiveTrendChart] = useState(null);
  const documentHiddenRef = useRef(false);
  const pagehideRef = useRef(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const [promptContent, setPromptContent] = useState({});
  const isOpenLiveTrendEditPageFlag = useSelector(isOpenLiveTrendEditPage);
  const updateIsOpenLiveTrendPage = (flag) => dispatch(setIsOpenLiveTrendEditPage(flag));

  const autoSaveFunction = useCallback(async () => {
    if (documentHiddenRef.current || pagehideRef.current) {
      documentHiddenRef.current = false;
      pagehideRef.current = false;
      return;
    }
    if (document.hidden) {
      documentHiddenRef.current = true;
      await postDashboard(currentVessel.id, selectedDashboard, true);
      return;
    }
    pagehideRef.current = true;
    await postDashboard(currentVessel.id, selectedDashboard, true);
  }, [selectedDashboard]);

  useEffect(() => {
    // when user leave Connect, dashboard will be saved
    document.addEventListener("visibilitychange", autoSaveFunction);
    window.addEventListener("pagehide", autoSaveFunction);
    return () => {
      document.removeEventListener("visibilitychange", autoSaveFunction);
      window.removeEventListener("pagehide", autoSaveFunction);
    };
  }, [autoSaveFunction]);

  useEffect(() => {
    return () => {
      dispatch(setIsOpenLiveTrendEditPage(false));
    }
  }, []);

  return (
    <Box>
      <Confirm
        when={showPrompt}
        title={t(promptContent.title)}
        message={t(promptContent.message)}
        cancelText={t(promptContent.cancelText)}
        okText={t(promptContent.okText)}
        onOK={promptContent.okHandler}
        onCancel={promptContent.cancelHandler}
        isDelete={promptContent.isDelete}
      />
      <Drawer
        anchor="right"
        variant="persistent"
        open={true}
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: DRAWER_WIDTH,
            marginTop: "98px", //for top bar
            padding: "8px",
            background: "rgba(37, 45, 57, 0.8)",
            boxSizing: "border-box",
          },
        }}
      >
        <AddItemsBase
          currentVessel={currentVessel}
          content={drawerContent}
          setDrawerContent={setDrawerContent}
          selectedDashboard={selectedDashboard}
          setSelectedDashboard={setSelectedDashboard}
          setIsOpenLiveTrendPage={updateIsOpenLiveTrendPage}
          setIsDrawerOpen={setIsDrawerOpen}
          setEditingLiveTrendChart={setEditingLiveTrendChart}
          isLiveTrendAddonEnabled={isLiveTrendAddonEnabled}
        />
      </Drawer>
      <Box
        open={isDrawerOpen}
        sx={{
          userSelect: "none",
          MozUserSelect: "none",
          WebkitUserSelect: "none",
          background: "#252d3980 50%",
          position: "relative",
          minWidth: "1500px",
        }}
      >
        {isOpenLiveTrendEditPageFlag ? (
          <EditLiveTrendGraph
            vesselId={currentVessel.id}
            setIsOpenLiveTrendPage={updateIsOpenLiveTrendPage}
            selectedDashboard={selectedDashboard}
            setSelectedDashboard={setSelectedDashboard}
            setDashboards={setDashboards}
            setShowPrompt={setShowPrompt}
            setPromptContent={setPromptContent}
            setIsDrawerOpen={setIsDrawerOpen}
            editingLiveTrendChart={editingLiveTrendChart}
            setEditingLiveTrendChart={setEditingLiveTrendChart}
          />
        ) : (
          <EditDashboardDisplay
            currentVessel={currentVessel}
            selectedDashboard={selectedDashboard}
            setSelectedDashboard={setSelectedDashboard}
          />
        )}
      </Box>
    </Box>
  );
});

DashboardEditPage.propTypes = {
  currentVessel: PropTypes.object,
  isDrawerOpen: PropTypes.bool,
  setIsDrawerOpen: PropTypes.func,
  selectedDashboard: PropTypes.object,
  setSelectedDashboard: PropTypes.func,
  setDashboards: PropTypes.func,
  isLiveTrendAddonEnabled: PropTypes.bool,
};
